var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79,9.342c.317,0,.585.268.585.585v6.654c0,.317-.268.585-.585.585h-2.051c-.317,0-.585-.268-.585-.585v-6.654c0-.317.268-.585.585-.585h2.051M4.79,8.342h-2.051c-.872,0-1.585.713-1.585,1.585v6.654c0,.872.713,1.585,1.585,1.585h2.051c.872,0,1.585-.713,1.585-1.585v-6.654c0-.872-.713-1.585-1.585-1.585h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.026,5.878c.317,0,.585.268.585.585v10.118c0,.317-.268.585-.585.585h-2.051c-.317,0-.585-.268-.585-.585V6.463c0-.317.268-.585.585-.585h2.051M11.026,4.878h-2.051c-.872,0-1.585.713-1.585,1.585v10.118c0,.872.713,1.585,1.585,1.585h2.051c.872,0,1.585-.713,1.585-1.585V6.463c0-.872-.713-1.585-1.585-1.585h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.261,2.834c.317,0,.585.268.585.585v13.162c0,.317-.268.585-.585.585h-2.051c-.317,0-.585-.268-.585-.585V3.419c0-.317.268-.585.585-.585h2.051M17.261,1.834h-2.051c-.872,0-1.585.713-1.585,1.585v13.162c0,.872.713,1.585,1.585,1.585h2.051c.872,0,1.585-.713,1.585-1.585V3.419c0-.872-.713-1.585-1.585-1.585h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAnalytics);
export default __webpack_public_path__ + "static/media/Sidebar_Analytics.2d4cba4ddfb22db53b46d79f23b5b4c8.svg";
export { ForwardRef as ReactComponent };